<template>
  <div class="card is-smallshadow">
    <div class="card-body py-3">
      <h2 class="heading-small text-grey mb-2">
       {{ $t('adviserSettings.invoiceData') }}
      </h2>

      <div class="width-narrow">
        <validation-observer
          ref="adviser-settings-invoice-form"
          tag="form">
          <div class="form-group">
            <template v-if="langId === 2">
              <label for="tin">{{ $t('ui.tin') }}</label>

              <validation-provider
                rules="required"
                name="tin"
                v-slot="{ errors }">
                <f-input-wrapper>
                  <f-input
                    v-model="data.nip"
                    :state="errors.length ? 'invalid' : null"/>
                </f-input-wrapper>
                <div class="additional-info">
                  <f-icon name="info" />
                  <span>{{ $t('validation.tin') }}</span>
                </div>
                <div class="invalid-feedback">
                  {{ errors[0] }}
                </div>
              </validation-provider>
            </template>
            <template v-else>
              <label for="nip">{{ $t('ui.nip') }}</label>

              <validation-provider
                rules="required"
                name="nip"
                v-slot="{ errors }">
                <f-input
                  v-model="data.nip"
                  :state="errors.length ? 'invalid' : null"/>
                <div class="invalid-feedback">
                  {{ errors[0] }}
                </div>
              </validation-provider>
            </template>
          </div>
        </validation-observer>
      </div>
    </div>
    <div class="card-footer pt-3 pb-4 text-right">
      <f-button
        theme="primary"
        big
        @click.prevent="validateForm">
        {{ $t('ui.save') }}
      </f-button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import FormUtils from '@/utils/FormUtils.js';

export default {
  name: 'adviser-settings-invoice-info',
  props: {
    nip: {
      type: String
    }
  },
  computed: {
    ...mapGetters({
      langId: 'getUserLanguageId'
    })
  },
  data() {
    return {
      data: {
        nip: '',
      }
    }
  },
  mounted() {
    this.data.nip = this.nip;
  },
  methods: {
    submitForm () {
      let formDataToSend = {
        nip: this.data.nip
      };

      FormUtils.submit(this, {
        endpoint: '/api/adviser/adviser/update-invoice',
        formData: formDataToSend,
        successTitle: this.$t('ui.savedChanges'),
        successText: this.$t('adviserSettingsInvoiceInfo.yourDataForInvoicesHasBeenSaved'),
        errorTitle: this.$t('ui.errorOccurred'),
        errorText: this.$t('adviserSettings.yourDataModifyError'),
        successAction: () => {
          this.$bus.$emit('adviser-settings-reload');
        }
      });
    },
    validateForm () {
      FormUtils.validate(this.$refs['adviser-settings-invoice-form'], this.submitForm);
    },
  }
}
</script>
